import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'OrganizedUnit/PostOu', method: 'POST', body: body, token: token })
}
